import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'repeat'
})
export class RepeatPipe implements PipeTransform {
  transform(str: string, times: number): string {
    return Array(times + 1).join(str);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/users/repeat.pipe.ts